module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-152x152-a52551932972c7c649f75ae755ba50ac.png";